import React from 'react';
import styled from 'styled-components';
import { Tooltip } from 'components/Base/Tooltip';

export interface CardTitleProps {
  title: string;
  className?: string;
  maxLength?: number;
}

const TitleContainer = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  font-size: 1.25rem;
  font-family: Montserrat, sans-serif;
  margin-bottom: 4px;
  width: 100%;

  @media (max-width: 768px) {
    font-size: 1.125rem;
  }

  @media (max-width: 576px) {
    font-size: 1rem;
  }
`;

const TitleText = styled.div`
  position: relative;
  font-weight: 600;
  display: inline-block;
  width: 100%;
  white-space: normal;
  overflow-wrap: break-word;
  word-wrap: break-word;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  max-width: 100%;
`;

const CardTitle: React.FC<CardTitleProps> = ({
  title,
  className,
  maxLength = 30,
}) => {
  const formatTitle = (text: string) => {
    if (text === text.toUpperCase()) {
      return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    }
    return text;
  };

  const formattedTitle = formatTitle(title);
  const isTitleLong = formattedTitle.length > maxLength;
  const displayTitle = isTitleLong
    ? `${formattedTitle.substring(0, maxLength)}...`
    : formattedTitle;

  return (
    <TitleContainer className={className}>
      {isTitleLong ? (
        <Tooltip title={formattedTitle}>
          <TitleText>{displayTitle}</TitleText>
        </Tooltip>
      ) : (
        <TitleText>{displayTitle}</TitleText>
      )}
    </TitleContainer>
  );
};

export default CardTitle;
